<template>
  <div
    class="vcore_input-group"
    :class="{ 'vcore_has-error': !!error, 'feedback-padding': !error }"
  >
    <label
      v-if="label"
      class="vcore_input-label"
      :class="{ 'vcore_input-label_optional': !required }"
      :style="{ color: labelColor }"
      :for="id | idFormat"
      :id="ariaLabelledBy | ariaFormat"
    >{{ label }}</label
    >
    <button v-if="popover" :ref="`${id}_label-icon` | idFormat" class="popover-trigger"
      aria-label="More info" type="button">
      <i class="vcore_icon icon-info"></i>
    </button>
    <Popover v-if="popover && popoverTarget"
             :placement="popover.placement"
             :target="popoverTarget"
             :title="popover.title"
             :content="popover.content"
    ></Popover>
    <masked-input
      type="text"
      v-model="content"
      @blur="handleBlur"
      class="vcore_input"
      :placeholder="placeholder"
      :class="{ 'vcore_input--error': !!error, [size]: !!size }"
      :name="name || label"
      :aria-labelledby="ariaLabelledBy | ariaFormat"
      :aria-invalid="`${!!error}`"
      :aria-required="`${required}`"
      :aria-errormessage="ariaErrorMessage"
      :id="id | idFormat"
      :mask="moneyMask"
      :guide="false"
      :disabled="disabled"
      inputmode="decimal"
      pattern="[0-9]*"
    ></masked-input>
    <span class="vcore_input-addon"> </span>
    <div
      class="vcore_input-feedback feedback-position"
      :id="errorId | idFormat"
      v-if="error"
      aria-live="assertive"
    >{{ error }}</div>
  </div>
</template>

<script>
  import MaskedInput from "vue-text-mask";
  import createNumberMask from "text-mask-addons/dist/createNumberMask";
  import Popover from "./Popover";

  export default {
    name: "Money",
    props: {
      label: String,
      name: String,
      value: {},
      placeholder: String,
      labelStyle: String,
      inputStyle: String,
      size: {
        default: ""
      },
      labelColor: String,
      required: Boolean,
      error: String,
      formName: String,
      popover: Object,
      disabled: {
        type: Boolean,
        default: false
      }
    },
    components: {
      MaskedInput,
      Popover
    },
    data() {
      return {
        content: this.value,
        moneyMask: createNumberMask({
          requireDecimal: false,
          allowDecimal: true,
          integerLimit: 14
        }),
        popoverTarget: null
      };
    },
    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.content = newVal;
        }
      },
      content(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.content = newVal;

          this.$emit('input', newVal);
        }
      }
    },
    computed: {
      id() {
        if (this.formName) {
          return `${this.formName}_${this.label}`;
        }
        return this.label || this.name;
      },

      ariaLabelledBy() {
        return `${this.id}--label`;
      },

      ariaErrorMessage() {
        return this.error ? this.$options.filters.idFormat(this.errorId) : undefined;
      },

      errorId() {
        return `${this.id}--error`;
      }
    },
    methods: {
      handleBlur() {
        this.content = this.$options.filters.toUSD(
          this.$options.filters.decimalPadding(this.content, 2)
        );

        this.$emit("blur");
      }
    },
    mounted() {
      this.popoverTarget = this.$refs[`${this.$options.filters.idFormat(this.id)}_label-icon`];
      this.moneyMask = createNumberMask({
        requireDecimal: false,
        allowDecimal: true,
        integerLimit: 14
      })
    }
  }
</script>

<style lang="scss" scoped>
input.vcore_input {
  &.small {
    height: 30px;
  }

  &.large {
    height: 50px;
  }
}

.vcore_input-group {

  .vcore_input-label + button.popover-trigger {
    display: inline-block;
    color: $color_dark-blue;
    cursor: pointer;
    margin-left: 4px;

    .vcore_icon {
      font-size: 16px;
    }
  }
}

.feedback-position {
  position: absolute;
}

.popover-trigger {
  border-radius: 500px;
  border: none;
  background: none;
  width: fit-content;
  height: fit-content;
  padding: 0;
  margin-left: 4px;
}

.popover-trigger:focus-visible {
  outline: 2px solid black;
  outline-offset: 2px;
}
</style>
